import React, { useRef } from 'react';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../contexts/ThemeContext';
import './TooltipInfos.css';

export const TooltipIcon = ({ tooltipKey, placement = 'top' }) => {
  const { t } = useTranslation();
  const { isDark } = useTheme();  // ✅ Adicione
  const target = useRef(null);


  const tooltipText = t(`TOOLTIPS.${tooltipKey}`, 'Sem informação disponível');


  const renderTooltip = (props) => (
    <Tooltip id={`tooltip-${tooltipKey}`} className={`custom-tooltip ${isDark ? 'dark' : 'light'}`} {...props}>
      {tooltipText}
    </Tooltip>
  );


  return (
    <OverlayTrigger
      placement={placement}
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip}
    >
      <button
        ref={target}
        className={`tooltip-icon-button ${isDark ? 'dark' : 'light'}`}  // ✅ Adicione
        aria-label="Informações"
        type="button"
      >
        <AiOutlineInfoCircle size={18} />
      </button>
    </OverlayTrigger>
  );
};
